<template>
  <div class="interparty-consultation container" v-if="interpartyConsultationsData">
    <h3 class="heading-title">
      <a :href="interpartyConsultationUrl">CONSULTA INTERPARTIDISTA</a>
    </h3>
    <div class="interparty-general-info">
      <div class="wrap-bulletin">
        <div class="bulletin">
          AVANCE
          <span class="number-bulletin" v-html="interpartyConsultationsData.bulletin.nationalBulletinNumber"></span>
        </div>

        <span v-html="currentTime" class="current-time"></span>
      </div>

      <div class="label">
        Mesas informadas:
        {{
          formatPercent(
            interpartyConsultationsData.bulletin.percentageInformedTables,
          )
        }}
      </div>

      <div class="interparty-info-results">
        <div class="wrap-info-results">
          <div class="circle">
            <i class="icon-check"></i>
          </div>
          <div class="label">
            Votos Válidos:
            {{ format(interpartyConsultationsData.bulletin.validVotes) }}
          </div>
        </div>

        <div class="wrap-info-results">
          <div class="circle">
            <i class="icon-close"></i>
          </div>
          <div class="label">
            No marcados:
            {{ format(interpartyConsultationsData.bulletin.notMarkedVotes) }}
          </div>
        </div>

        <div class="wrap-info-results">
          <div class="circle">
            <i class="icon-stop"></i>
          </div>
          <div class="label">
            Nulos:
            {{ format(interpartyConsultationsData.bulletin.nullVotes) }}
          </div>
        </div>
      </div>
    </div>
    <template v-for="(item, idx) in interpartyConsultationsData.groupedCandidates">
      <div class="card-interparty" :class="`c-${idx}`">
        <h3 class="title-interparty" v-html="item.politicalParty.name.toLowerCase()"></h3>

        <div class="info-candidate" :class="{ full: index == 0 }" v-for="(candidate, index) in item.candidates"
          :key="candidate.id">
          <template v-if="index == 0">
            <img class="round" :alt="item.politicalParty.name" :title="candidate.name" :src="`${candidate.photo}?w=70`"
              :height="70" :width="70" />
          </template>

          <div class="info-general">
            <div class="name-candidate" v-html="candidate.name.toLowerCase()"></div>

            <div class="bar">
              <div class="r" :style="{ width: candidate.percentage * 100 + '%' }"></div>
            </div>

            <div class="votes-candidate">
              Votos:
              {{ format(candidate.votes) }}
            </div>
          </div>

          <hr class="vert" />

          <div class="percentage-candidate" v-html="formatPercent(candidate.percentage)"></div>
        </div>
      </div>
    </template>
    <div class="button">
      <a :href="interpartyConsultationUrl" class="btn" target="_blank" rel="nofollow">VER CONSULTA COMPLETA</a>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import "dayjs/locale/es";
import { useLRWebSocketV2 } from "../../../features/lr-websocket-v2.js";

export default {
  props: {
    interpartyConsultationUrl: {
      type: String,
    },
  },
  created() {
    this.$store.dispatch("elections/getLegislative2026_home");
    useLRWebSocketV2(this.$store);
  },
  computed: {
    interpartyConsultationsData() {
      return this.$store.getters["elections/legislative2026_home"];
    },

    currentTime() {
      if (!this.interpartyConsultationsData) return "";

      return dayjs(this.interpartyConsultationsData.bulletin.date)
        .locale("es")
        .format("hh:mm a");
    },
  },

  methods: {
    formatPercent(value) {
      if (value === null || value === undefined) return "";

      return value.toLocaleString("es-CO", {
        style: "percent",
        maximumFractionDigits: 2,
      });
    },

    format(value) {
      if (value === null || value === undefined) return "";

      return value.toLocaleString("es-CO");
    },
  },
};
</script>
